import { toUniqueArray } from '../../../../backend/utils/objectUtils';
export function filterApprovedShiftParticipantsByPositionIds(data) {
    return [
        {
            column: 'shiftId',
            op: '=',
            value: data.shiftId,
        },
        {
            column: 'positionId',
            op: 'in',
            value: toUniqueArray(data.shiftParticipations.map((p) => p.positionId)),
        },
        {
            column: 'status',
            op: '=',
            value: 'approved',
        },
    ];
}
